import { render, staticRenderFns } from "./date-picker.vue?vue&type=template&id=5fac2f7e&scoped=true&"
import script from "./date-picker.vue?vue&type=script&lang=js&"
export * from "./date-picker.vue?vue&type=script&lang=js&"
import style0 from "./date-picker.vue?vue&type=style&index=0&id=5fac2f7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fac2f7e",
  null
  
)

export default component.exports